import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    let _this = this;
    setTimeout(function(){
      _this.element.style.display = 'none';
    }, 3000);
    
  }
}